import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface CalendarState {
    success: boolean,
    authUrl: string,
    hasToken: boolean,
}

const calendarSlice = createSlice({
    name: "calendar",
    initialState: {
        authUrl: '',
        hasToken: false,
        success: false,
    } as CalendarState,
    reducers: {
        setCalendar: (state, action: PayloadAction<CalendarState>) => {
            state.success = action.payload.success;
            state.authUrl = action.payload.authUrl;
            state.hasToken = action.payload.hasToken;
        },
    },
});

export const {setCalendar} = calendarSlice.actions;
export const calendarReducer = calendarSlice.reducer;
